import { BloodTestTracker } from "../api-objects/BloodTestTracker";
import { DnaTestTracker } from "../api-objects/DnaTestTracker";
import { BASE_URL, requestOptionsGET } from "../Constants";
import { TrackingStatus } from "../Enums";
import { ErrorWithMessageCallback, GetTrackerByUserIdSuccessCallback, SuccessWithTrackerCallback } from "./callback-helpers";

export async function getTrackerByUserId(
    userId: string,
    idToken: string,
    onSuccess: GetTrackerByUserIdSuccessCallback,
    onError: ErrorWithMessageCallback,
    handleSessionExpiry?: () => void,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/track/${userId}`, requestOptionsGET(idToken))
        if (response.ok) {
            const trackers: DnaTestTracker[] = await response.json()
            onSuccess(trackers)
        } else if (response.status === 401 && handleSessionExpiry) {
            handleSessionExpiry();
        } else {
            const errorMessage = response.statusText || "Dna Test not found";
            onError(errorMessage);
        }
    } catch (error) {
        console.error("Get tracker failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}

export async function getBloodTrackerByUserId(
    userId: string,
    idToken: string,
    onSuccess: SuccessWithTrackerCallback,
    onError: ErrorWithMessageCallback,
    handleSessionExpiry?: () => void,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/blood-track/${userId}`, requestOptionsGET(idToken))
        if (response.ok) {
            const trackers: BloodTestTracker[] = await response.json()
            onSuccess(trackers)
        } else if (response.status === 401 && handleSessionExpiry) {
            handleSessionExpiry();
        } else {
            const errorMessage = response.statusText || "Blood exam not found";
            onError(errorMessage);
        }
    } catch (error) {
        console.error("Get blood tracker failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}

export async function updateTrackerByOrderId(
    orderId: string,
    idToken: string,
    status: TrackingStatus,
    onSuccess: (tracker: DnaTestTracker) => void,
    onError: ErrorWithMessageCallback,
    handleSessionExpiry?: () => void,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/track/order/${orderId}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify(
                {
                    tracking_status: status,
                }
            )
        })
        if (response.ok) {
            const tracker: DnaTestTracker = await response.json()
            onSuccess(tracker)
        } else if (response.status === 401 && handleSessionExpiry) {
            handleSessionExpiry();
        } else {
            const errorMessage = response.statusText || "Failure";
            onError(errorMessage);
        }
    } catch (error) {
        console.error("Update tracker failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}

export async function getDnaTrackersByStatus(
    status: TrackingStatus,
    idToken: string,
    onSuccess: (trackers: DnaTestTracker[]) => void,
    onError: ErrorWithMessageCallback,
    handleSessionExpiry?: () => void,
) {
    try {
        // If status is null, fetch all
        const url = `${BASE_URL}/api/track/status/${status}`;
        const response = await fetch(url, requestOptionsGET(idToken));
        if (response.ok) {
            const trackers: DnaTestTracker[] = await response.json();
            onSuccess(trackers);
        } else if (response.status === 401 && handleSessionExpiry) {
            handleSessionExpiry();
        } else {
            const errorMessage = response.statusText || "Dna Test not found";
            onError(errorMessage);
        }
    } catch (error) {
        console.error("Get trackers by status failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}